import React, { useEffect, useState, useRef, } from 'react'
import Header from 'components/home/Header'
import ValoresApi from '../services/robinhood/ValoresApi';
import MunicipioSelecionado from 'components/extratos/MunicipioSelecionado';
import MunicipioSelecionarModal from 'components/municipios/MunicipioSelecionarModal';
import ContentBoxValores from 'components/extratos/ContentBoxValores';
import RelatorioChart from 'components/extratos/RelatorioChart';
import TransferenciasGlobaisAnos from 'components/transferenciasGlobais/TransferenciasGlobaisAnos';
import Preloader from 'components/home/Preloader';
import { Link, json, useLocation, useNavigate } from 'react-router-dom';
import Meses from '../services/Meses';
import ExtratoComparativoChart from 'components/extratos/ExtratoComparativoChart';
import MunicipioAdicionar from 'components/extratos/MunicipioAdicionar';
import ChartColors from 'components/ChartColors';
import DownloadTable from '../components/extratos/DownloadTable';
import CategoriasNavMenu from 'components/categorias/CategoriasNavMenu';
import MunicipiosApi from 'services/robinhood/MunicipiosApi';

export default function ExtratoComparativoTransferencia() {
    const location = useLocation();
    const navigate = useNavigate();
    const [indicador, setIndicador] = useState({ id: null, indicador: null, nome: null });
    const [valoresTransferencias, setValoresTransferencias] = useState([]);
    const [anos, setAnos] = useState(localStorage.getItem('valores_anos') ? JSON.parse(localStorage.getItem('valores_anos')) : [{ 'ano': new Date().getFullYear() }]);
    const [ano, setAno] = useState(localStorage.getItem('ano_selecionado') || new Date().getFullYear());
    const [municipio, setMunicipio] = useState(localStorage.getItem('municipio') ? JSON.parse(localStorage.getItem('municipio')) : { 'id': null, 'municipio': null });
    const [loaded, setLoaded] = useState(false);
    const categorias = { 'indices': 1, 'transferencias': 2, 'dados_basicos': 3, 'saneamentos': 4, 'conservacoes': 5 };
    const [municipios, setMunicipios] = useState(localStorage.getItem('municipios') ? JSON.parse(localStorage.getItem('municipios')) : [{ id: null }]);
    const tableRef = useRef();

    const [valores, setValores] = useState({ indices: 1, transferencias: 1 })
    const ApiUrl = process.env.REACT_APP_API_URL;


    useEffect(() => {
        if (!municipio.id || !municipios[0].id) {
            navigate('/municipios');
        }
        document.getElementById('toggle-menu').className = 'theme-blush';
        localStorage.setItem('ano_selecionado', ano);
    }, []);

    useEffect(() => {
        if (municipio.id && indicador.id && ano && municipios.length > 0) {
            getValores(ano);
        }
    }, [indicador, municipio, municipios, ano]);

    useEffect(() => {
        if (location.state) {
            setLoaded(false);
            setIndicador(location.state.indicador);
            localStorage.setItem('indicador', JSON.stringify(location.state.indicador));
        }
    }, [location.state]);


    const handlerMunicipio = (_municipio) => {

        if (!_municipio.id) {
            return;
        }

        setMunicipio(_municipio);
        localStorage.setItem('municipio', JSON.stringify(_municipio));
        const storage = JSON.parse(localStorage.getItem('municipios'));
        const municipiosFilter = storage.filter(item => item.id != _municipio.id);
        municipiosFilter.push(_municipio);
        municipiosFilter.reverse();
        setMunicipios(municipiosFilter);
        localStorage.setItem('municipios', JSON.stringify(municipiosFilter));

    }

    const getValores = async (_ano) => {
        setLoaded(false);
        const indicador_id = JSON.parse(localStorage.getItem('indicador')).id;
        let municipios_ids = [];
        if (municipios.length < 1) {
            return false;
        }
        municipios.map(item => municipios_ids.push(item.id));

        await new ValoresApi().anoMunicipiosIndicador(_ano, municipios_ids, indicador_id).then(response => {
            setValoresTransferencias(response);
        });
        setLoaded(true);
        scrollWindow();
    }

    const handlerAno = (_ano) => {
        setAno(_ano);
        localStorage.setItem('ano_selecionado', _ano);
    }

    const uniqueById = (data, key) => {
        return [
            ... new Map(
                data.map(x => [key(x), x])
            ).values()
        ];
    }

    const handlerMunicipioAdicionarTodos = () => {
        new MunicipiosApi().all().then(response => {
            if (response) {
                const municipiosFilter = response.filter(item => item.id != municipio.id);
                municipiosFilter.unshift(municipio);
                setMunicipios(municipiosFilter);
                localStorage.setItem('municipios', JSON.stringify(municipiosFilter));
            }
        });
    }

    const handlerMunicipioAdicionar = (_municipio) => {
        const municipiosStorage = JSON.parse(localStorage.getItem('municipios'));
        let municipioValido = true;

        if (!_municipio.id) {
            municipioValido = false;
        }
        municipiosStorage.forEach(item => {
            if (item.id == _municipio.id) {
                municipioValido = false;
            }
        });

        if (municipioValido == false) {
            return;
        }

        const municipiosFilter = municipiosStorage.filter(item => item.id != _municipio.id);
        municipiosFilter.push(_municipio);
        setMunicipios(municipiosFilter);
        localStorage.setItem('municipios', JSON.stringify(municipiosFilter));
    }

    const removerMunicipio = (_municipio_id) => {
        let storage = JSON.parse(localStorage.getItem('municipios'));
        const uniques = [];
        storage.map(item => {
            if (item.id != _municipio_id) {
                uniques.push(item)
            }
        });
        setMunicipios(uniques);
        localStorage.setItem('municipios', JSON.stringify(uniques));
    }

    const clearMunicipios = () => {
        const municipioStorage = JSON.parse(localStorage.getItem('municipio'));
        setMunicipios([municipioStorage]);
        localStorage.setItem('municipios', JSON.stringify([municipioStorage]));
    }

    const scrollWindow = () => {
        let mybutton = document.getElementById("buttomScrollUp");
        window.onscroll = function () { scrollFunction() };
        function scrollFunction() {
            if (document.documentElement.scrollTop > 60) {
                mybutton.style.display = "block";
            } else {
                mybutton.style.display = "none";
            }
        }
    }

    const handleScrool = (_element) => {
        const element = document.getElementById(_element);
        let elementPosition = null;
        if (element) {
            elementPosition = element.getBoundingClientRect().top;
            window.scrollTo({
                top: elementPosition + window.scrollX - 80,
                behavior: 'smooth',
            });
        }
    }

    const TableRows = () => {
        let linhas = [];
        valoresTransferencias.map(municipio => {
            let linha = { 'municipio_id': null, 'municipio': null, 'ibge6': null, 'meses': [], 'valorTotal': 0.0000 };

            for (let mes_id = 1; mes_id < 13; mes_id++) {
                municipio.map((valor) => {
                    let mes = { mes_id: mes_id, valor: null };
                    if (valor.mes_id == mes_id) {
                        mes.valor = valor.valor;
                        linha.municipio = valor.municipio;
                        linha.municipio_id = valor.municipio_id;
                        linha.ibge6 = valor.ibge6;
                        linha.meses.push(mes);
                        if (valor.valor) {
                            let floatValor = parseFloat(String(valor.valor).replaceAll('.', '').replace(',', '.'));
                            if (!isNaN(floatValor))
                                linha.valorTotal = (linha.valorTotal + floatValor);

                        }
                    }
                });
            }
            linhas.push(linha);
        });

        return <>
            {linhas && linhas.map((linha, i) => {
                return <tr key={Math.random()}>
                    <td>
                        {linha.municipio_id != municipio.id
                            ? <a onClick={() => removerMunicipio(linha.municipio_id)}>
                                &nbsp;<i className='zmdi zmdi-close text-danger ' style={{ cursor: 'pointer' }}> &nbsp; </i>
                            </a>
                            : <a> &nbsp;<i className> &nbsp; </i></a>}
                    </td>
                    <td className='hidden'> {linha.ibge6} </td>
                    <td className={`text-left`} key={Math.random()} >

                        <i className='zmdi zmdi-circle small m-r-10' style={{ color: ChartColors[i] }}> </i>
                        {linha.municipio ? linha.municipio : <span className='text-muted small'>Não foram encontrados dados referentes ao município</span>} {linha.municipio_id == municipio.id ? < span className={`m-l-10 small label bg-pink`} style={{ color: 'white' }}>SELECIONADO</span> : null}
                    </td>
                    {
                        Meses.map(iMes => {
                            let td = <td className='text-right'> </td>;
                            linha.meses.map((mes) => {
                                let valor = parseFloat(String(mes.valor).replaceAll('.', '').replace(',', '.'));
                                if (mes.mes_id == iMes.id)
                                    // td = <td className={`text-right`}> { } {mes.valor}</td>
                                    td = <td className={`text-right`}>  {Intl.NumberFormat('pt-BR', { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(Math.round((valor + Number.EPSILON) * 100) / 100)}</td>
                            })
                            return td;
                        }
                        )
                    }
                    < td className='text-right bg-light'  > {Intl.NumberFormat('pt-BR').format(Math.round((linha.valorTotal + Number.EPSILON) * 100) / 100)} </td>
                </tr >
            })
            }
        </>
    }

    const TableValores = () => {
        return <>
            <DownloadTable tableRef={tableRef} template={{ municipio: 'extrato-comparativo-transferencias', categoria: indicador.nome, mes: indicador.indicador, ano: ano }} />
            {/* <a className='btn btn-link text-muted' style={{ position: 'absolute', top: '10px', right: '10px', fontSize: '13px', cursor: 'pointer' }}
                onClick={() => window.open(`${ApiUrl}uploads/download?ano=${ano}&categoria_id=${categorias.transferencias}`, '_blank')}>
                <i className='zmdi zmdi-download' style={{ fontSize: '15px', }}></i> <small> DOWNLOAD </small>
            </a> */}
            {/* <Link to={`${ApiUrl}uploads/download?ano=${ano}&categoria_id=2` } target='_blank' >xxx</Link> */}
            <table ref={tableRef} className="table table-sm small table-hover" key={Math.random()} style={{ cursor: 'default' }}>
                <thead>
                    <th> <i className='zmdi zmdi-delete text-muted' title='REMOVER TODOS' onClick={clearMunicipios} style={{ cursor: 'pointer' }}></i> </th>
                    <th className="hidden">IBGE6</th>
                    <th className="text-left">MUNICÍPIO</th>
                    <th className="text-right">JANEIRO</th>
                    <th className="text-right">FEVEREIRO</th>
                    <th className="text-right">MARÇO</th>
                    <th className="text-right">ABRIL</th>
                    <th className="text-right">MAIO</th>
                    <th className="text-right">JUNHO</th>
                    <th className="text-right">JULHO</th>
                    <th className="text-right">AGOSTO</th>
                    <th className="text-right">SETEMBRO</th>
                    <th className="text-right">OUTUBRO</th>
                    <th className="text-right">NOVEMBRO</th>
                    <th className="text-right">DEZEMBRO</th>
                    <th className={`text-right `} style={{ backgroundColor: '#8BC34A', color: 'white' }}> TOTAL <small style={{ fontSize: '10px' }}>(ANUAL)</small></th>
                </thead>
                <tbody>
                    <TableRows key={Math.random()} />
                </tbody>
            </table>
        </>
    }

    const topFunction = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const CategoriaMenu = () => {
        return (
            <div style={{}}>
                <div className="container-fluid">
                    <div className="card widget_3 ">
                        <ul className="row clearfix list-unstyled m-b-0">
                            <li className={valoresTransferencias.length > 0 ? "col-lg-2 col-md-5 col-sm-12 waves-effect" : "col-lg-2 col-md-6 col-sm-12 waves-effect "} style={{ pointerEvents: 'none', borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px', marginLeft: '15px' }}>

                                <div className="body" style={{ paddingLeft: '15px', paddingRight: '0px', cursor: 'pointer' }}>
                                    <div className="row">
                                        <div className="col-9">
                                            <h5 className={"m-t-0"} style={{ fontSize: '15px' }} > TRANSFERÊNCIAS </h5>
                                        </div>
                                        <div className="col-12">
                                            <div className="progress m-t-20">
                                                <div className="progress-bar l-green" role="progressbar" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100" style={{ width: '100%' }}></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </li>
                            <li className={"col-lg-2 col-md-5 col-sm-12 waves-effect  "} style={{ pointerEvents: 'auto', backgroundColor: '#F8F9FA', }}>
                                <Link to={'/extratos/comparativo/indice'} style={{ textDecoration: 'none', color: 'black' }} className='text-black'>
                                    <div className="body" style={{ paddingLeft: '0px', paddingRight: '0px', cursor: 'pointer' }} onClick={() => handleScrool('ÍNDICES')}>
                                        <div className="row">
                                            <div className="col-9">
                                                <h5 className={valoresTransferencias.length > 0 ? "m-t-0" : "m-t-0 "} style={{ fontSize: '15px' }}>ÍNDICES</h5>
                                            </div>

                                            <div className="col-12">
                                                <div className="progress m-t-20">
                                                    <div className="progress-bar l-blush" role="progressbar" aria-valuenow="12" aria-valuemin="0" aria-valuemax="100" style={{ width: '100%' }}></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div >
        )
    }

    return <>
        <div className='container-fluid'>

            <Header >
                <h5 style={{ marginLeft: '20px', marginBottom: '20px' }} > <i className='zmdi zmdi-money-box'></i> <span style={{ display: 'inline-block', width: '180px' }}> TRANSFERÊNCIAS </span> {ano && <small className='m-l-20 text-muted'>  EXTRATO COMPARATIVO DE  {ano} </small>}
                </h5>
                <section className='container-fluid'>
                    <div className='row'>
                        <MunicipioSelecionado municipio={municipio} />

                        {(ano && indicador.id) && <div class="col-lg-5 col-sm-6 col-md-6 col-xs-12 p-1" style={{ cursor: 'default' }}>
                            <div class="card" style={{ backgroundColor: '#7F99A6' }}>
                                <div class="body text-white">
                                    <h4 style={{ marginBottom: '0px', textTransform: 'uppercase' }}><i className='zmdi zmdi-group' style={{ fontSize: '30px' }}></i>  <span className='' style={{ color: '' }}>{ }</span> {indicador.nome}  </h4>
                                    <span className='m-l-30'>CRITÉRIO SELECIONADO</span>
                                </div>
                            </div>
                        </div>}

                        {(ano && indicador.id) && <div class="col-lg-3 col-sm-6 col-md-6 col-xs-12 p-1" style={{ cursor: 'pointer' }}>

                            <div class="card bg-green">
                                <a href='' data-toggle='modal' data-target='#largeModalMunicipioAdicionar' className='small text-white' style={{ textDecoration: 'none', color: 'white' }}>
                                    <div class="body text-white">
                                        <h4 style={{ marginBottom: '0px', textTransform: 'uppercase' }}> <i className='zmdi zmdi-plus' style={{ fontSize: '30px', verticalAlign: '' }}></i> <i className='zmdi zmdi-city m-r-5' style={{ fontSize: '30px', }}></i>  <span className='' style={{ color: '' }}><span style={{ fontSize: '10px' }}></span> ADICIONAR </span> </h4>
                                        <span className='m-l-30'> MUNICÍPIO PARA COMPARAÇÃO</span>

                                    </div>
                                </a>
                            </div>
                        </div>}
                    </div>

                </section>
                <div className='row'>
                    <div className='col-md-12'>
                        <TransferenciasGlobaisAnos anos={anos} handlerAno={handlerAno} ano={ano} backgroundColor={'bg-blue-grey'} retornar={false} downloadUrl={`${ApiUrl}uploads/download?ano=${ano}&categoria_id=2`} buttonLabel={`EXPORTAR POR CRITÉRIO TRANSFERÊNCIAS ${ano}`} />
                    </div>
                    {/* <div className='col-md-3 text-right' style={{ marginBottom: '-0px', marginTop: '-15px', height: '35px' }}>
                        <Link to={'/extratos/comparativo/indice'} className={`btn rounded  m-b-5 m-r-5 col-md-5 text-muted `}
                            style={{ fontSize: '12px', color: '', 'width': '' }}>
                            <i className='zmdi zmdi-dot-circle-alt p-r-5' style={{ fontSize: '', color: '' }}> </i>
                            ÍNDICES
                        </Link>
                        <span className={`btn rounded bg-blue-grey m-b-5 m-r-5 col-md-5`}
                            style={{ fontSize: '12px', color: 'white', width: ' ', cursor: 'pointer' }}>
                            <i className='zmdi zmdi-dot-circle-alt p-r-5' style={{ fontSize: '', color: '' }}> </i>
                            TRANSFERÊNCIAS
                        </span>
                    </div> */}
                </div>
                <div className='row'>
                    <div className='col-12'>
                        <CategoriaMenu ></CategoriaMenu>
                    </div>
                </div>
            </Header >

            {!(ano && indicador.id) && <section className='content' style={{ marginTop: '-20px' }}> <h6 className='m-l-20 text-muted'> <i className="zmdi zmdi-caret-left-circle blink_me m-r-5"></i> <span className=''> SELECIONE O CRITÉRIO DESEJADO PARA EXIBIÇÃO DE DADOS</span> </h6></section>}
            {!loaded && ano && indicador.id && (
                <section className='content' style={{ marginTop: '-20px' }}>
                    <div className='text-center m-t-20 m-b-20'>
                        <Preloader />
                        {/* <h6 className='text-muted m-t-10'>Carregando dados...</h6> */}
                    </div>
                </section>
            )}
            {loaded
                ? <section className='content' style={{ marginTop: '-40px', display: loaded == true ? 'block' : 'none' }} key={Math.random()} >
                    {(loaded && valoresTransferencias[0].length > 0) ? <ContentBoxValores titulo="TRANSFERÊNCIAS" subtitulo={` COMPARATIVO DAS TRANSFERÊNCIAS DO MUNICÍPIO DE ${municipio.municipio}`} color='yellowgreen' key={Math.random()} >
                        {municipios.length < 38 && <ExtratoComparativoChart key={Math.random()}
                            valores={valoresTransferencias}
                            label={''} titulo={''} subtitulo={''} backgroundColor={'#8BC34A'}  >
                        </ExtratoComparativoChart>}
                        {valoresTransferencias && <TableValores key={Math.random()} />}
                    </ContentBoxValores> : <span className='content' style={{ marginTop: '-20px' }}> <h6 className='m-l-20 text-muted'><i class="zmdi zmdi-info"></i> NÃO FORAM ENCONTRADOS DADOS REFERENTES AO PERÍODO SELECIONADO </h6></span>
                    }
                </section>
                : null
            }
            <MunicipioSelecionarModal titulo='ALTERAR MUNICÍPIO' handlerMunicipio={handlerMunicipio} navigate={''} />

            <MunicipioAdicionar titulo={'ADICIONAR MUNICÍPIO'}
                municipioAdicionar={handlerMunicipioAdicionar}
                municipioAdicionarTodos={handlerMunicipioAdicionarTodos}
            >
            </MunicipioAdicionar>

            <a onClick={topFunction} id="buttomScrollUp" className='btn btn-rouded  waves-effect'>
                <i className='zmdi zmdi-caret-up-circle' style={{ marginTop: '0px', paddingTop: '-10px' }}></i>
            </a>
        </div>
    </>
}